export const EMAIL_SERVICE_ID = "service_patg3ug";
export const USER_ID = "lwRVNdF0INIX67T97";
export const EMAIL_TEMPLATE_CONTACT_US = "template_oaxuzh4";
export const EMAIL_TEMPLATE_ENTRY_FORM = "template_y3h6y05";
export const EMAIL_TEMPLATE_RECEIPT = "template_x49bv46";
export const EMAIL_TEMPLATE_SPECIAL_CAT_FORM = "template_ymrjj89";
export const EMAIL_TEMPLATE_RECEIPT_SPECIAL = "template_ureeu0a";
